<div class="full-page login-banner w-100">
  <div class="container">
    <div class="d-flex justify-content-center">
      <img alt="" [height]="100" src="assets/images/logos/NYJLogo.png" class="logo mb-5" />
    </div>

    <!--Right Side-->
    <div class="bg-white rounded-4 right-side-login text-center">
      <img
        class="maintenance-icon"
        alt="maintenance-icon"
        height="100"
        draggable="false"
        src="assets/images/maintenance-icon.svg"
      />
      <h5
        class="text-primary text-center mt-4 mb-0"
        [innerHTML]="'maintenancepage.title.text' | translate | markdownTranslate"
      ></h5>
      <p class="font-size-14" [innerHTML]="'maintenancepage.message' | translate | markdownTranslate"></p>
    </div>
  </div>
</div>
